import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import router from './router'
import { urls } from './config'
import store from './store'
import './icons'
import i18n from './i18n'
import './mixin'
import './filters'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BIcon, BIconChevronDown, BootstrapVue } from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'
import VueAxios from 'vue-axios'
import VeeValidate from 'vee-validate'
import VueAuthenticate from 'vue-authenticate'
import VModal from 'vue-js-modal'
import Vuex from 'vuex'

import LocaleHelper from '@/utils/LocaleHelper'

export const EventBus = new Vue()

Vue.component('multiselect', Multiselect)
Vue.component('BIcon', BIcon)
Vue.component('BIconChevronDown', BIconChevronDown)
Vue.use(VModal)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
})
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: urls.api,
  loginUrl: '/login_check',
  tokenPrefix: 'onesource_',
  tokenPath: 'token',
  storageNamespace: '',
  registerUrl: ''
})

Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false

axios.defaults.baseURL = urls.api
axios.interceptors.request.use(function (config) {
  if (!config.headers.accept && config.headers.common.Accept && config.headers.common.Accept.indexOf('*/*') !== -1) {
    config.headers.accept = 'application/json'
  }

  const userLocale = LocaleHelper.getUserLocale()
  if (userLocale) {
    config.headers['Accept-Language'] = userLocale
  }

  return config
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

/*
const createApp = () => {
  const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  })
  // .$mount('#app')

  return { app, router, store }
}
export default createApp
*/
